<template>
<div class="chapter">
<div class="inner_page">
<p class="part"><a id="page_xx"></a>PART ONE</p>
<p class="part1">MINISTER OF MUNITIONS, 1917–1918</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?7a3a4fc4